<template>
  <circle cx="13" cy="13" r="12" :stroke="stroke" fill="#fff" stroke-width="1.3" />
</template>

<script>
  export default {
    props: {
      stroke: {
        type: String,
        default: '#586E82'
      }
    }
  };
</script>
